import decode from 'jwt-decode'

const AdminAuth = (): boolean => {
  const adminId: number = 2
  const access: string | null = localStorage.getItem('access')
  const refresh: string | null = localStorage.getItem('refresh')

  if (!access || !refresh) {
    return false
  }

  try {
    // { exp: 121325664189 }
    const { exp, user_id }: { exp: number; user_id: number } = decode(refresh)
    if (exp < new Date().getTime() / 1000 || user_id !== adminId) {
      return false
    }
  } catch (error) {
    return false
  }

  return true
}

export default AdminAuth
